import ModelBase from "../../../../../../framework/core/mvvm/model_base";
import { TableData } from "../../data/table_data";

export class SeatModelBase extends ModelBase {
    //玩家座位信息数据
    seatPlayerData:TableData.SeatPlayerData = null;

    Init(){
        this.onInit();
    }

    onInit() {};
}
